module.exports = __webpack_public_path__ + "assets/scoober-logo-he-8420ac.svg";